module.exports = __webpack_public_path__ + "img/bth_tunbu_pre.3b3b5293.png";